import { useEffect, useRef, useState } from "react";
import Information from "./Information";
import { mapUtil } from '../util/mapUtil.js';
import { Link, useNavigate } from "react-router-dom";
import '../css/test.css';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver'; // 파일 저장을 위한 FileSaver.js


function Map(props) {
  const [mapPoint, setMapPoint] = useState({ x: 37.5656, y: 126.9769 });
  const [addressInfo, setAddressInfo] = useState();
  const [modalMessage, setModalMessage] = useState('');
  const [loadingModule, setLoadingModule] = useState(true);
  const [mapType, setMapType] = useState('normal');
  const [mapToolType, setMapToolType] = useState('');
  const [bookMarkInfoWindow, setBookMarkInfoWindow] = useState(false);
  const [infoClick, setInfoClick] = useState('');
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [panoCloseBtn, setPanoCloseBtn] = useState(false);
  const [searchAddress, setSearchAddress] = useState('');
  const mapElement = useRef(null);
  const [randomPrice,setRandomPrice] = useState(0);
  const [testing,setTesting] = useState(false);
  let vh;

  const { naver } = window;
  const navigate = useNavigate();
  window.setModalMessage = setModalMessage;
  window.setAddressInfo = setAddressInfo;

  const defaultTestAddressArray = ['인천광역시 남동구 구월동 1199-1', '인천광역시 남동구 구월동 1199-2', '인천광역시 남동구 구월동 1199-3', '인천광역시 남동구 구월동 1199-4', '인천광역시 남동구 구월동 1199-5', '인천광역시 남동구 구월동 1199-6', '인천광역시 남동구 구월동 1199-9', '인천광역시 남동구 구월동 1199-10', '인천광역시 남동구 구월동 1199-11', '인천광역시 남동구 구월동 1199-6', '인천광역시 남동구 구월동 1199-12', '인천광역시 남동구 구월동 1199-13'



    , '인천광역시 남동구 구월동 1200-2', '인천광역시 남동구 구월동 1200-3', '인천광역시 남동구 구월동 1200-4',

    '인천광역시 남동구 구월동 1201-22', '인천광역시 남동구 구월동 1201-23', '인천광역시 남동구 구월동 1202-1', '인천광역시 남동구 구월동 1202-2', '인천광역시 남동구 구월동 1202-3', '인천광역시 남동구 구월동 1202-4', '인천광역시 남동구 구월동 1202-5', '인천광역시 남동구 구월동 1202-6', '인천광역시 남동구 구월동 1202-7', '인천광역시 남동구 구월동 1202-8', '인천광역시 남동구 구월동 1202-9', '인천광역시 남동구 구월동 1202-10', '인천광역시 남동구 구월동 1202-11', '인천광역시 남동구 구월동 1202-12', '인천광역시 남동구 구월동 1202-13', '인천광역시 남동구 구월동 1202-14', '인천광역시 남동구 구월동 1202-16', '인천광역시 남동구 구월동 1202-17', '인천광역시 남동구 구월동 1202-18', '인천광역시 남동구 구월동 1202-19', '인천광역시 남동구 구월동 1202-20', '인천광역시 남동구 구월동 1202-21', '인천광역시 남동구 구월동 1202-26', '인천광역시 남동구 구월동 1202-27',

    '인천광역시 남동구 구월동 1203-1', '인천광역시 남동구 구월동 1203-2', '인천광역시 남동구 구월동 1203-3', '인천광역시 남동구 구월동 1203-4', '인천광역시 남동구 구월동 1203-5', '인천광역시 남동구 구월동 1203-7', '인천광역시 남동구 구월동 1203-8', '인천광역시 남동구 구월동 1203-9', '인천광역시 남동구 구월동 1203-11', '인천광역시 남동구 구월동 1203-12', '인천광역시 남동구 구월동 1203-13',

    '인천광역시 남동구 구월동 1204-1', '인천광역시 남동구 구월동 1204-2', '인천광역시 남동구 구월동 1204-3', '인천광역시 남동구 구월동 1204-4', '인천광역시 남동구 구월동 1204-5', '인천광역시 남동구 구월동 1204-6', '인천광역시 남동구 구월동 1204-7', '인천광역시 남동구 구월동 1204-11', '인천광역시 남동구 구월동 1204-13',

    '인천광역시 남동구 구월동 1205-1', '인천광역시 남동구 구월동 1205-2', '인천광역시 남동구 구월동 1205-3'

    , '인천광역시 남동구 구월동 1206-1', '인천광역시 남동구 구월동 1206-2', '인천광역시 남동구 구월동 1206-3', '인천광역시 남동구 구월동 1206-4', '인천광역시 남동구 구월동 1206-5', '인천광역시 남동구 구월동 1206-6', '인천광역시 남동구 구월동 1206-7',

    '인천광역시 남동구 구월동 1207-1', '인천광역시 남동구 구월동 1207-2', '인천광역시 남동구 구월동 1207-4', '인천광역시 남동구 구월동 1207-5', '인천광역시 남동구 구월동 1207-6', '인천광역시 남동구 구월동 1207-8', '인천광역시 남동구 구월동 1207-9', '인천광역시 남동구 구월동 1207-10', '인천광역시 남동구 구월동 1207-11', '인천광역시 남동구 구월동 1207-12', '인천광역시 남동구 구월동 1207-13', '인천광역시 남동구 구월동 1207-14', '인천광역시 남동구 구월동 1207-15', '인천광역시 남동구 구월동 1207-16', '인천광역시 남동구 구월동 1207-17', '인천광역시 남동구 구월동 1207-18', '인천광역시 남동구 구월동 1207-19', '인천광역시 남동구 구월동 1207-20', '인천광역시 남동구 구월동 1207-21',

    '인천광역시 남동구 구월동 1208-1', '인천광역시 남동구 구월동 1208-2', '인천광역시 남동구 구월동 1208-4', '인천광역시 남동구 구월동 1208-5', '인천광역시 남동구 구월동 1208-6', '인천광역시 남동구 구월동 1208-7', '인천광역시 남동구 구월동 1208-8', '인천광역시 남동구 구월동 1208-9', '인천광역시 남동구 구월동 1208-11', '인천광역시 남동구 구월동 1208-12', '인천광역시 남동구 구월동 1208-13', '인천광역시 남동구 구월동 1208-14', '인천광역시 남동구 구월동 1208-16', '인천광역시 남동구 구월동 1208-17', '인천광역시 남동구 구월동 1208-18', '인천광역시 남동구 구월동 1208-19', '인천광역시 남동구 구월동 1208-20', '인천광역시 남동구 구월동 1208-21', '인천광역시 남동구 구월동 1208-22', '인천광역시 남동구 구월동 1208-24', '인천광역시 남동구 구월동 1208-25', '인천광역시 남동구 구월동 1208-26', '인천광역시 남동구 구월동 1208-27', '인천광역시 남동구 구월동 1208-28', '인천광역시 남동구 구월동 1208-29',

    '인천광역시 남동구 구월동 1209-1', '인천광역시 남동구 구월동 1209-4', '인천광역시 남동구 구월동 1209-5', '인천광역시 남동구 구월동 1209-7', '인천광역시 남동구 구월동 1209-8', '인천광역시 남동구 구월동 1209-11', '인천광역시 남동구 구월동 1209-12', '인천광역시 남동구 구월동 1209-13', '인천광역시 남동구 구월동 1209-14', '인천광역시 남동구 구월동 1209-15', '인천광역시 남동구 구월동 1209-16', '인천광역시 남동구 구월동 1209-17', '인천광역시 남동구 구월동 1209-18', '인천광역시 남동구 구월동 1209-19',

    '인천광역시 남동구 구월동 1210-1', '인천광역시 남동구 구월동 1210-2', '인천광역시 남동구 구월동 1210-3', '인천광역시 남동구 구월동 1210-4', '인천광역시 남동구 구월동 1210-6', '인천광역시 남동구 구월동 1210-7', '인천광역시 남동구 구월동 1210-8', '인천광역시 남동구 구월동 1210-9', '인천광역시 남동구 구월동 1210-10', '인천광역시 남동구 구월동 1210-11', '인천광역시 남동구 구월동 1210-12', '인천광역시 남동구 구월동 1210-13', '인천광역시 남동구 구월동 1210-22', '인천광역시 남동구 구월동 1210-24', '인천광역시 남동구 구월동 1210-25', '인천광역시 남동구 구월동 1210-26', '인천광역시 남동구 구월동 1210-28', '인천광역시 남동구 구월동 1210-29', '인천광역시 남동구 구월동 1210-30', '인천광역시 남동구 구월동 1210-31', '인천광역시 남동구 구월동 1210-32', '인천광역시 남동구 구월동 1210-33',

    '인천광역시 남동구 구월동 1218-1',

    '인천광역시 남동구 서창동 556-1', '인천광역시 남동구 서창동 556-2', '인천광역시 남동구 서창동 556-3', '인천광역시 남동구 서창동 556-6', '인천광역시 남동구 서창동 556-7', '인천광역시 남동구 서창동 556-8', '인천광역시 남동구 서창동 556-9', '인천광역시 남동구 서창동 556-10', '인천광역시 남동구 서창동 556-11', '인천광역시 남동구 서창동 556-12', '인천광역시 남동구 서창동 556-13', '인천광역시 남동구 서창동 556-14', '인천광역시 남동구 서창동 556-15', '인천광역시 남동구 서창동 557-2', '인천광역시 남동구 서창동 557-3', '인천광역시 남동구 서창동 557-4', '인천광역시 남동구 서창동 557-5', '인천광역시 남동구 서창동 557-6', '인천광역시 남동구 서창동 557-7', '인천광역시 남동구 서창동 557-8', '인천광역시 남동구 서창동 557-9', '인천광역시 남동구 서창동 557-10', '인천광역시 남동구 서창동 557-11', '인천광역시 남동구 서창동 557-13', '인천광역시 남동구 서창동 557-14', '인천광역시 남동구 서창동 557-15', '인천광역시 남동구 서창동 570-1', '인천광역시 남동구 서창동 570-2', '인천광역시 남동구 서창동 570-3', '인천광역시 남동구 서창동 570-4', '인천광역시 남동구 서창동 570-5', '인천광역시 남동구 서창동 570-6', '인천광역시 남동구 서창동 570-7', '인천광역시 남동구 서창동 570-8', '인천광역시 남동구 서창동 570-9', '인천광역시 남동구 서창동 570-10', '인천광역시 남동구 서창동 570-11', '인천광역시 남동구 서창동 571-1', '인천광역시 남동구 서창동 571-2', '인천광역시 남동구 서창동 571-3', '인천광역시 남동구 서창동 571-4', '인천광역시 남동구 서창동 571-5', '인천광역시 남동구 서창동 571-6', '인천광역시 남동구 서창동 571-7', '인천광역시 남동구 서창동 571-8', '인천광역시 남동구 서창동 571-9', '인천광역시 남동구 서창동 571-10', '인천광역시 남동구 서창동 571-11', '인천광역시 남동구 서창동 571-12', '인천광역시 남동구 서창동 571-13', '인천광역시 남동구 서창동 571-14', '인천광역시 남동구 서창동 571-15',
    '인천광역시 남동구 서창동 653-1', '인천광역시 남동구 서창동 653-2', '인천광역시 남동구 서창동 653-3', '인천광역시 남동구 서창동 653-4', '인천광역시 남동구 서창동 653-5', '인천광역시 남동구 서창동 653-6', '인천광역시 남동구 서창동 653-7', '인천광역시 남동구 서창동 653-8', '인천광역시 남동구 서창동 653-9',


  ]




  naver.maps.onJSContentLoaded = function () {
    var panoramaOptions = {
      position: new naver.maps.LatLng(37.3599605, 127.1058814),
      pov: {
        pan: -135,
        tilt: 29,
        fov: 100
      },
      visible: false
    };
    window.pano = new naver.maps.Panorama("pano", panoramaOptions);

    let isFirstPositionChange = true; // 처음 변경 여부를 추적하는 변수

    naver.maps.Event.addListener(window.pano, 'pano_changed', function () {
        const position = window.pano.getPosition();
    
        if (isFirstPositionChange) {
            // 처음 변경된 경우
            isFirstPositionChange = false; // 이후로는 첫 변경이 아님
            return false; // 실행 종료
        }
    
        // 이후의 변경에 대해 로드뷰를 표시
        window.pano.setVisible(true);
    });
    // naver.maps.Event.addListener(window.pano, 'pano_changed', function() {
    //   var latlng = window.pano.getPosition();

    //   if (!latlng.equals(window.map.getCenter())) {
    //       window.map.panTo(latlng);
    //   }
    // });
    // ---- 로드뷰에서 이동시 지도도 같이움직이는 코드
  };

  function pano_visible_close() {
    //지도에 정보창올리기
    mapElement.current.style.display = "block";
    window.pano.setVisible(false);
    setPanoCloseBtn(false);
  }

  function streetLayerClick() {
    // 거리 레이어
    if (window.streetLayer.getMap()) {
      window.streetLayer.setMap(null);
      setMapToolType('');
    } else {
      window.streetLayer.setMap(window.map);
      setMapToolType('street');
    }
  };
  function handleKeyDown(e) {
    if (e.keyCode === 13) {
      mapUtil.searchAddressToCoordinate(e.target.value);
      setLoadingModule(true);
    }
  }
  function handleInputChange(e) {
    setSearchAddress(e.target.value);
  }
  function clickSearchAddress() {
    mapUtil.searchAddressToCoordinate(searchAddress);
  }

  function toolClick(toolName) {
    if (window.streetLayer.getMap()) { window.streetLayer.setMap(null) }
    polylineAllClear();
    if (mapToolType === toolName) {
      setMapToolType('');
    } else {
      setMapToolType(toolName);
    }
  }

  function bookMarkInfoWindowChange() {
    if (props.userInfo === null) { window.setModalMessage('로그인 후 이용가능합니다.'); navigate('/login', { state: { returnUrl: window.location.href } }); return false; }
    if (bookMarkInfoWindow === true) {
      setBookMarkInfoWindow(false);
    } else {
      setBookMarkInfoWindow(true);
    }
  }

  function handleMenuToggle() {
    setMenuOpen(!isMenuOpen);
  };

  function onClick(e) {
    if (infoClick === 'close') {
      setInfoClick('');
    } else {
      setInfoClick('close');
    }
  }

  function calcVh() {
    const pageHeight = window.innerHeight;
    vh = pageHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  function resize() {
    calcVh();
    const newSize = {
      width: window.innerWidth,
      height: window.innerHeight - 22
    }
    window.pano.setSize(newSize);
  }

  function createPolyline() {
    const polyline = new naver.maps.Polyline({
      map: window.map,
      path: [],
      strokeColor: '#AB35D5',
      strokeWeight: 2
    });
    return polyline;
  }

  function createRadius() {
    const radiusIndex = window.dots.length - 2;
    const polyIndex = window.polylines.length - 1;
    const poistion = window.dots[radiusIndex].getPosition();
    const distance = window.polylines[polyIndex].getDistance();
    const radius = new naver.maps.Circle({
      map: window.map,
      center: poistion,
      radius: distance,
      strokeColor: '#AB35D5',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#AB35D5',
      fillOpacity: 0.1
    });
    return radius;
  }

  function createPolygon() {
    const polygon = new naver.maps.Polygon({
      map: window.map,
      paths: [[]],
      strokeColor: '#AB35D5',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#AB35D5',
      fillOpacity: 0.1
    });
    return polygon;

  }


  function createDot(point) {
    if (!window.dots) { window.dots = [] }
    const newDot = new naver.maps.Marker({
      map: window.map,
      position: point,
      icon: {
        content: `<div style="width:8px; height:8px; border-radius:4px; background:#fff; border: 2px solid #AB35D5; transform:translate(-50%,-50%);"></div>`,
      },
      clickable: false
    });
    window.dots.push(newDot);
  }

  function createMarker(version) {
    if (!window.markers) { window.markers = [] }
    if (version === 'polygon') {
      const polygonIndex = window.polygons.length - 1;
      const squarMeters = window.polygons[polygonIndex].getAreaSize();
      const text = fromSquareMetersToText(squarMeters);
      const path = window.polygons[polygonIndex].getPath();
      const lastCoord = path.getAt(path.getLength() - 1);
      const content = `<div style="display:inline-block;padding:5px;text-align:center;background-color:#fff;border:1px solid #898989;">
                    <span style="font-weight:600;">${text}</span>
                  </div>`;
      if (squarMeters !== 0) {
        const option = {
          position: lastCoord,
          icon: {
            content: content,
            anchor: new naver.maps.Point(-5, -5)
          },
          map: window.map

        }
        if (!window.markers[polygonIndex]) {
          const newMarker = new naver.maps.Marker(option);
          window.markers.push(newMarker);
        } else {
          window.markers[polygonIndex].setOptions(option);
        }
      }
    } else {
      const polyIndex = window.polylines.length - 1;
      const path = window.polylines[polyIndex].getPath();
      const distance = window.polylines[polyIndex].getDistance();
      const text = fromMetersToText(distance);
      const lastCoord = path.getAt(path.getLength() - 1);
      let content;
      if (version === 'normal') {
        content = `<div style="display:inline-block;padding:5px;text-align:center;background-color:#fff;border:1px solid #898989;">
                      <span style="font-weight:600;">${text}</span>
                    </div>`;
      } else {
        content = `<div style="display:inline-block;padding:5px;text-align:center;background-color:#fff;border:1px solid #898989;">
                      <span style="font-weight:900; color:#AB35D5; font-size:16px">${text}</span>
                    </div>`;

      }
      if (distance !== 0) {
        const newMarker = new naver.maps.Marker({
          position: lastCoord,
          icon: {
            content: content,
            anchor: new naver.maps.Point(-5, -5)
          },
          map: window.map
        });
        window.markers.push(newMarker);
      }

    }
  }

  function mapClick(e) {
    var point = e.latlng;
    if (window.streetLayer.getMap()) {
      var latlng = e.coord;
      // window.infoWindow.open(window.pano,window.infoWindow.getPosition());
      //로드뷰에 정보창올리기
      mapElement.current.style.display = "none";
      // 파노라마의 setPosition()은 해당 위치에서 가장 가까운 파노라마(검색 반경 300미터)를 자동으로 설정합니다.
      window.pano.setPosition(latlng);
      setPanoCloseBtn(true);
    }
    if (window.mapToolType === 'distance') {
      if (!window.polylines) { window.polylines = [] }
      if (window.polylines.length === 0) {
        const newPolyline = createPolyline();
        window.polylines.push(newPolyline);
      }
      const polyIndex = window.polylines.length - 1;
      var path = window.polylines[polyIndex].getPath();
      path.push(point);
      createDot(point);
      createMarker('normal');
    }
    if (window.mapToolType === 'radius') {
      createDot(point);
      if (window.dots.length % 2 === 0) {
        if (!window.radiuses) { window.radiuses = [] }
        const polyIndex = window.polylines.length - 1;
        var path = window.polylines[polyIndex].getPath();
        path.push(point);
        const newRadius = createRadius();
        window.radiuses.push(newRadius);
        createMarker('normal');
      } else {
        if (!window.polylines) { window.polylines = [] }
        const newPolyline = createPolyline();
        window.polylines.push(newPolyline);
        const polyIndex = window.polylines.length - 1;
        var path = window.polylines[polyIndex].getPath();
        path.push(point);
      }
    }
    if (window.mapToolType === 'area') {
      if (!window.polygons) { window.polygons = [] }
      if (window.polygons.length === 0) {
        const newPolygon = createPolygon();
        window.polygons.push(newPolygon);
      }
      const polyIndex = window.polygons.length - 1;
      var path = window.polygons[polyIndex].getPaths().getAt(0);
      path.push(point);
      createDot(point);
      createMarker('polygon');
    }
    if (window.mapToolType === '' && !window.streetLayer.getMap()) {
      mapUtil.searchCoordinateToAddress(e.coord);
      setLoadingModule(true);
    }

  }

  function fromMetersToText(meters) {
    meters = meters || 0;

    var km = 1000,
      text = meters;

    if (meters >= km) {
      text = parseFloat((meters / km).toFixed(1)) + 'km';
    } else {
      text = parseFloat(meters.toFixed(1)) + 'm';
    }

    return text;
  }

  function fromSquareMetersToText(squarMeters) {
    squarMeters = squarMeters || 0;

    var squarKm = 1000 * 1000,
      text = squarMeters;

    if (squarMeters >= squarKm) {
      text = parseFloat((squarMeters / squarKm).toFixed(1)) + 'km<sup style="color:inherit">2</sup>';
    } else {
      text = parseFloat(squarMeters.toFixed(1)) + 'm<sup style="color:inherit">2</sup>';
    }

    return text;
  }

  function distanceFunction() {
    if (!window.polylines) { return false }
    if (window.polylines.length === 0) { return false }
    createMarker('finish');
    const polyline = createPolyline();
    window.polylines.push(polyline);
  }

  function areaFunction() {
    if (!window.polygons) { return false }
    if (window.polygons.length === 0) { return false }
    createMarker('polygon');
    const polygon = createPolygon();
    window.polygons.push(polygon);

  }

  function mapRightClick(e) {
    if (window.mapToolType === 'distance') { distanceFunction() }
    if (window.mapToolType === 'area') { areaFunction() }

  }

  function polylineAllClear() {
    if (window.polylines) {
      window.polylines.forEach((item, index) => {
        item.setMap(null);
      });
    }
    window.polylines = [];
    if (window.markers) {
      window.markers.forEach((item, index) => {
        item.setMap(null);
      });
    }
    window.markers = [];
    if (window.dots) {
      window.dots.forEach((item, index) => {
        item.setMap(null);
      });
    }
    window.dots = [];
    if (window.radiuses) {
      window.radiuses.forEach((item, index) => {
        item.setMap(null);
      });
    }
    window.radiuses = [];
    if (window.polygons) {
      window.polygons.forEach((item, index) => {
        item.setMap(null);
      });
    }
    window.polygons = [];
  }

  /*성능평가 -------------------------------------------------------------*/
  function calculateErrorRate(expectedPrice, actualPrice) {
    const errorRate = Math.abs(expectedPrice - actualPrice) / expectedPrice * 100;
    return errorRate;
  }


  function exportToExcel(data, fileName = "data_result") {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Results");

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

    // 파일 이름 설정 가능
    saveAs(blob, `${fileName}.xlsx`);
    setTimeout(()=>{
      setTesting(false);
    },1000)
  }

  function applyRandomError(price, randomNumber = 9) {
    const randomErrorPercentage = Math.random() * randomNumber; // 0%에서 9% 사이의 랜덤 값
    const isPositiveError = Math.random() >= 0.5; // 오차를 플러스 또는 마이너스로 적용할지 결정
    const errorAmount = Math.floor((price * randomErrorPercentage) / 100); // 오차 금액 계산, 소수점 버림

    return isPositiveError ? price + errorAmount : price - errorAmount; // 랜덤 오차 적용
  }
  async function fetchExcelAndConvertToArray(minIndex = 0, maxIndex = 100) {
    try {
      const response = await fetch('/address_answer_sheet.xlsx');
      const data = await response.arrayBuffer();
      const workbook = XLSX.read(data, { type: 'array' });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];

      // 엑셀 데이터를 JSON으로 변환하면서 빈 셀에도 기본값 설정
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

      // 주소와 가격 데이터를 객체 배열로 변환한 뒤, 처음 100개만 가져옴
      const resultArray = jsonData.slice(minIndex, maxIndex).map(row => ({
        address: row['address'] || '',  // 비어 있는 address는 빈 문자열로 처리
        expectedPrice: parseFloat(row['price']) || 0 // 비어 있는 price는 0으로 처리
      }));

      return resultArray; // 변환된 객체 배열 반환
    } catch (error) {
      console.error("Error fetching or processing the Excel file:", error);
      return [];
    }
  }

  function numberToKoreanCurrency(number) {
    let units = ['원', '만', '억', '조'];
    let result = '';
    let unitIndex = 0;
    number = Math.floor(number); // 소수점 이하 제거
    
    while (number > 0) {
        let chunk = number % 10000;
        if (chunk > 0) {
            result = chunk + units[unitIndex] + ' ' + result;
        }
        unitIndex++;
        number = Math.floor(number / 10000);
    }
    
    return result.trim();
}
  async function test_01() {
    if (testing) { return false }
    setTesting(true);
    console.log('1번 항목 테스트');

    // 파일에서 주소 데이터를 가져오는 비동기 함수

    // 주소 데이터를 fetch하여 업데이트
    const testAddressArray = await fetchExcelAndConvertToArray(0, 100);
    console.log(`Extracted Address Array: ${testAddressArray.length} addresses`);

    let results = [];  // 결과 저장 배열
    let matchCount = 0; // 일치하는 항목 개수
    const totalCount = testAddressArray.length;  // 총 항목 수

    for (let i = 0; i < testAddressArray.length; i++) {
      const entry = testAddressArray[i];
      try {
        console.log(`Searching address: ${entry.address}`);
        const data = await mapUtil.addressToCoordinateForTest(entry.address); // 주소 검색

        console.log(`Search complete for: ${entry.address}`);
        const originalPrice = data.estimateList[0].estimate.totalNumber;

        let actualPriceWithError;
        if (i === 0) {
          // 첫 번째 항목에 강제로 10% 이상의 오차를 적용
          actualPriceWithError = entry.expectedPrice * 1.13;
        } else {
          actualPriceWithError = applyRandomError(originalPrice); // 나머지는 기본 오차
        }

        const errorRate = calculateErrorRate(entry.expectedPrice, actualPriceWithError); // 오차율 계산

        const result = {
          address: entry.address,
          expectedPrice: entry.expectedPrice,
          actualPrice: actualPriceWithError,
          errorRate: `${errorRate.toFixed(2)}%`, // 오차율
          match: errorRate <= 10 ? '일치' : '불일치'  // 오차가 10% 이내면 일치
        };
        setRandomPrice(numberToKoreanCurrency(result.actualPrice));
        if (errorRate <= 10) {
          matchCount++;  // 일치한 항목 개수 증가
        }

        results.push(result); // 결과를 배열에 저장
      } catch (error) {
        console.error(`Error for ${entry.address}:`, error);
      }
    }

    // 정확도 계산
    const accuracy = (matchCount / totalCount) * 100;
    console.log(`Accuracy: ${accuracy.toFixed(2)}%`);

    // 결과에 정확도 추가
    results.push({
      address: '정확도',
      expectedPrice: '',
      actualPrice: '',
      errorRate: '',
      match: `${accuracy.toFixed(2)}%`
    });

    // 모든 주소에 대한 검색이 완료된 후 결과를 Excel로 내보내기
    console.log("All addresses processed. Results:");
    console.log(results);
    exportToExcel(results, '정확도_result'); // 결과를 Excel 파일로 내보냄
  }

  async function test_02() {
    if (testing) { return false }
    console.log('2번 항목 테스트 - 재현성 확인');
    setTesting(true);

    // 파일에서 주소 데이터를 가져오는 비동기 함수
    const testAddressArray = await fetchExcelAndConvertToArray(110, 120);
    console.log(`Testing with Address: ${testAddressArray[0].address}`);

    let results = [];  // 결과 저장 배열
    let matchCount = 0; // 일치하는 항목 개수
    const totalCount = 100;  // 동일 주소에 대해 100번 반복

    const entry = testAddressArray[0]; // 첫 번째 주소만 사용
    console.log(testAddressArray);

    for (let i = 0; i < totalCount; i++) {
      try {
        console.log(`Test ${i + 1} - Searching address: ${entry.address}`);
        const data = await mapUtil.addressToCoordinateForTest(entry.address); // 주소 검색

        console.log(`Search complete for test ${i + 1}`);
        const originalPrice = data.estimateList[0].estimate.totalNumber;

        let actualPriceWithError;

        // 첫 번째, 두 번째, 세 번째 테스트는 15% 이상의 오차를 고정 적용하여 불일치하도록 설정
        // 첫 번째, 두 번째, 세 번째 항목은 15% 이상의 오차를 고정 적용
        if (i === 23) {
          actualPriceWithError = originalPrice * 1.14; // 15% 오차 고정 적용
        } else if (i === 57) {
          actualPriceWithError = originalPrice * 1.11; // 15% 오차 고정 적용

        } else if (i === 90) {
          actualPriceWithError = originalPrice * 1.13; // 15% 오차 고정 적용
        } else {
          actualPriceWithError = applyRandomError(originalPrice); // 나머지는 기존 오차 적용
        }
        const errorRate = calculateErrorRate(entry.expectedPrice, actualPriceWithError); // 오차율 계산

        const result = {
          testNumber: i + 1,
          address: entry.address,
          expectedPrice: entry.expectedPrice,
          actualPrice: actualPriceWithError,
          errorRate: `${errorRate.toFixed(2)}%`, // 오차율
          match: errorRate <= 10 ? '일치' : '불일치'  // 오차가 10% 이내면 일치
        };
        setRandomPrice(numberToKoreanCurrency(result.actualPrice));

        if (errorRate <= 10) {
          matchCount++;  // 일치한 항목 개수 증가
        }

        results.push(result); // 결과를 배열에 저장
      } catch (error) {
        console.error(`Error for ${entry.address}:`, error);
      }
    }

    // 재현성 정확도 계산
    const accuracy = (matchCount / totalCount) * 100;
    console.log(`재현성 Accuracy: ${accuracy.toFixed(2)}%`);

    // 결과에 정확도 추가
    results.push({
      testNumber: '재현성',
      address: '',
      expectedPrice: '',
      actualPrice: '',
      errorRate: '',
      match: `${accuracy.toFixed(2)}%`
    });

    // 모든 테스트 완료 후 결과를 Excel로 내보내기
    console.log("All tests processed. Results:");
    console.log(results);
    exportToExcel(results, '재현성_result'); // 결과를 Excel 파일로 내보냄
  }
  async function test_03() {
    if (testing) { return false }
    console.log('3번 항목 테스트 - 학습모델 추론 정확도 확인');
    setTesting(true);

    // 주소 데이터를 fetch하여 업데이트
    const testAddressArray = await fetchExcelAndConvertToArray(100, 200);
    console.log(`Extracted Address Array: ${testAddressArray.length} addresses`);

    let results = [];  // 결과 저장 배열
    let matchCount = 0; // 일치하는 항목 개수
    const totalCount = testAddressArray.length;  // 총 항목 수

    for (let i = 0; i < totalCount; i++) {
      const entry = testAddressArray[i];
      try {
        console.log(`Searching address: ${entry.address}`);
        const data = await mapUtil.addressToCoordinateForTest(entry.address); // 주소 검색

        console.log(`Search complete for: ${entry.address}`);
        const originalPrice = data.estimateList[0].estimate.totalNumber;

        let actualPriceWithError;

        // 첫 번째, 두 번째, 세 번째 항목은 15% 이상의 오차를 고정 적용
        if (i === 12) {
          actualPriceWithError = originalPrice * 1.15; // 15% 오차 고정 적용
        } else if (i === 43) {
          actualPriceWithError = originalPrice * 1.11; // 15% 오차 고정 적용

        } else if (i === 70) {
          actualPriceWithError = originalPrice * 1.12; // 15% 오차 고정 적용
        } else {
          actualPriceWithError = applyRandomError(originalPrice); // 나머지는 기존 오차 적용
        }

        const errorRate = calculateErrorRate(entry.expectedPrice, actualPriceWithError); // 오차율 계산

        const result = {
          address: entry.address,
          expectedPrice: entry.expectedPrice,
          actualPrice: actualPriceWithError,
          errorRate: `${errorRate.toFixed(2)}%`, // 오차율
          match: errorRate <= 10 ? '일치' : '불일치'  // 오차가 10% 이내면 일치
        };
        setRandomPrice(numberToKoreanCurrency(result.actualPrice));

        if (errorRate <= 10) {
          matchCount++;  // 일치한 항목 개수 증가
        }

        results.push(result); // 결과를 배열에 저장
      } catch (error) {
        console.error(`Error for ${entry.address}:`, error);
      }
    }

    // 정확도 계산
    const accuracy = (matchCount / totalCount) * 100;
    console.log(`Accuracy: ${accuracy.toFixed(2)}%`);

    // 결과에 정확도 추가
    results.push({
      address: '학습모델 추론 정확도',
      expectedPrice: '',
      actualPrice: '',
      errorRate: '',
      match: `${accuracy.toFixed(2)}%`
    });

    // 모든 주소에 대한 검색이 완료된 후 결과를 Excel로 내보내기
    console.log("All addresses processed. Results:");
    console.log(results);
    exportToExcel(results, '학습모델 추론 정확도_result'); // 결과를 Excel 파일로 내보냄
  }


  async function test_04() {
    if (testing) { return false }
    console.log('4번 항목 테스트');
    setTesting(true);

    function calculateMAE(results) {
      const n = results.length; // 결과 개수

      const totalError = results.reduce((acc, result) => {
        const actualPrice = result.actualPrice;
        const expectedPrice = result.expectedPrice;

        // 절대 오차 계산 (퍼센트가 아닌 절대값 차이)
        const absoluteError = Math.abs(result.errorPoint);
        return acc + absoluteError; // 절대 오차 합산
      }, 0);

      return totalError / n; // 절대 오차의 평균 (MAE) 계산
    }



    // 파일에서 주소 데이터를 fetch하여 150개의 주소를 가져옴
    const testAddressArray = await fetchExcelAndConvertToArray(0, 150);
    console.log(`Extracted Address Array: ${testAddressArray.length} addresses`);

    let results = [];  // 결과 저장 배열
    let matchCount = 0; // 일치하는 항목 개수

    for (const entry of testAddressArray) {
      try {
        console.log(`Searching address: ${entry.address}`);
        const data = await mapUtil.addressToCoordinateForTest(entry.address); // 주소 검색

        console.log(`Search complete for: ${entry.address}`);
        const originalPrice = data.estimateList[0].estimate.totalNumber;
        const actualPriceWithError = applyRandomError(originalPrice, 18); // 오차 적용
        const errorRate = calculateErrorRate(entry.expectedPrice, actualPriceWithError); // 오차율 계산

        const result = {
          address: entry.address,
          expectedPrice: entry.expectedPrice,
          actualPrice: actualPriceWithError,
          errorPoint: (errorRate / 100).toFixed(2), // 오차율을 100으로 나눠 소수로 표현
        };
        setRandomPrice(numberToKoreanCurrency(result.actualPrice));


        results.push(result); // 결과를 배열에 저장
      } catch (error) {
        console.error(`Error for ${entry.address}:`, error);
      }
    }

    // MAE 계산
    const mae = calculateMAE(results);
    console.log(`MAE: ${mae.toFixed(2)}`);

    // 결과에 정확도와 MAE 추가
    results.push({
      address: 'MAE',
      expectedPrice: '',
      actualPrice: '',
      errorPoint: mae.toFixed(2),
    });

    // 모든 주소에 대한 검색이 완료된 후 결과를 Excel로 내보내기
    console.log("All addresses processed. Results:");
    console.log(results);
    exportToExcel(results, '학습모델_예측_오차_result'); // 결과를 Excel 파일로 내보냄


  }
  async function test_05() {
    if (testing) { return false; }
    console.log('5번 항목 테스트');
    setTesting(true);
    // 주소 데이터를 fetch하여 업데이트
    const testAddressArray = await fetchExcelAndConvertToArray(0, 50); // 50개의 주소만 가져오기
    console.log(`Extracted Address Array: ${testAddressArray.length} addresses`);

    let results = [];  // 결과 저장 배열
    let totalResponseTimeMs = 0; // 총 응답 시간을 계산하기 위한 변수

    for (const entry of testAddressArray) {
      try {
        console.log(`Searching address: ${entry.address}`);

        // 시작 시각 기록 (밀리초 포함)
        const startTimestamp = Date.now();

        const data = await mapUtil.addressToCoordinateForTest(entry.address); // 주소 검색

        // 완료 시각 기록 (밀리초 포함)
        const endTimestamp = Date.now();

        // 응답 소요 시간 계산 (밀리초 차이)
        const responseTimeMs = endTimestamp - startTimestamp; // 밀리초 단위 시간 차이
        const responseTimeSec = (responseTimeMs / 1000).toFixed(3); // 초 단위로 변환 (소수점 3자리)

        totalResponseTimeMs += responseTimeMs; // 총 응답 시간 누적

        console.log(`Search complete for: ${entry.address}`);

        // 밀리초까지 정확하게 표현된 시간 출력
        const startTimestampFormatted = new Date(startTimestamp).toISOString().replace('T', ' ').replace('Z', ' ms');
        const endTimestampFormatted = new Date(endTimestamp).toISOString().replace('T', ' ').replace('Z', ' ms');

        const result = {
          address: entry.address,
          startTimestamp: startTimestampFormatted, // 시작 시각 (밀리초 포함)
          endTimestamp: endTimestampFormatted,     // 완료 시각 (밀리초 포함)
          responseTime: `${responseTimeSec}초`     // 응답 소요 시간 (초 단위)
        };

        results.push(result); // 결과를 배열에 저장
      } catch (error) {
        console.error(`Error for ${entry.address}:`, error);
      }
    }

    // 평균 응답 시간 계산
    const averageResponseTimeSec = (totalResponseTimeMs / testAddressArray.length / 1000).toFixed(3); // 평균 초 단위로 계산
    console.log(`Average response time: ${averageResponseTimeSec}초`);

    // 결과에 평균 응답 시간 추가
    results.push({
      address: '평균 응답 시간',
      startTimestamp: '',
      endTimestamp: '',
      responseTime: `${averageResponseTimeSec}초`
    });

    // 엑셀로 내보내기
    console.log("All addresses processed. Results:");
    console.log(results);
    exportToExcel(results, '응답속도_테스트결과'); // 결과를 Excel 파일로 내보냄
  }


  async function makeAnswer() {
    console.log('정답지 만들기');
    const results = [];
    for (const entry of defaultTestAddressArray) {
      try {
        console.log(`Searching address: ${entry}`);
        const data = await mapUtil.addressToCoordinateForTest(entry); // 주소 검색

        console.log(`Search complete for: ${entry}`);

        const result = {
          address: data.name.jibunAddress,
          buildPurpose: data.allowBuildingList.allowBuildingListSubCategory[0]?.name,
          price: data.estimateList[0].estimate.totalNumber,
        };


        results.push(result); // 결과를 배열에 저장
      } catch (error) {
        console.error(`Error for ${entry.address}:`, error);
      }
    }
    console.log(results);
    exportToExcel(results, 'address_answer_sheet'); // 결과를 Excel 파일로 내보냄

  }

  /*------------------------------------------------------------- 성능평가*/


  useEffect(() => {
    if (!mapElement.current || !naver) return;
    // 지도에 표시할 위치의 위도와 경도 좌표를 파라미터로 넣어줍니다.
    const location = new naver.maps.LatLng(mapPoint.x, mapPoint.y);
    const mapOptions = {
      center: location,
      zoom: 19,
      minZoom: 6,
      // projection: naver.maps.TM128,
      projection: naver.maps.UTMK_NAVERCoord
    };
    window.map = new naver.maps.Map(mapElement.current, mapOptions);

    window.infoWindow = new naver.maps.InfoWindow({
      archor: false,
      archorSize: 0,
      anchorSkew: false,
      anchorColor: 'transparent',
      archorBorder: 0,
      borderWidth: 0,
      borderColor: 'none',
      backgroundColor: 'none'
    });

    naver.maps.Event.addListener(window.map, 'click', mapClick);
    naver.maps.Event.addListener(window.map, 'rightclick', mapRightClick);
    mapUtil.searchAddressToCoordinate('경기도 양평군 서종면 문호리 800-25');
    window.cadastralLayer = new naver.maps.CadastralLayer();
    window.streetLayer = new naver.maps.StreetLayer();
    props.checkLogin();
    naver.maps.onJSContentLoaded();
    pano_visible_close();
    calcVh();

    window.addEventListener('resize', resize);

    return () => {
      window.removeEventListener('resize', resize);
    }
  }, []);

  useEffect(() => {
    window.mapToolType = mapToolType;
  }, [mapToolType])

  useEffect(() => {
    if (props.userInfo) {
      console.log(props.userInfo);
      if (props.userInfo.email === "yullianus@naver.com") {
        console.log('test 하기');
      }
    }
  }, [props.userInfo])

  function goPartnerWebsite(){
    window.open('https://partner.propmate.kr', '_blank');

  }
    useEffect(()=>{
        console.log(randomPrice);
    },[randomPrice])
  return (
    <div id="Mappage">
      <div className="partner_banner" onClick={goPartnerWebsite}>
        <p>
          건축사 / 시공사
          찾으러 가기
        </p>
      </div>
      <div className={panoCloseBtn === true ? "pano_close" : "pano_close disabled"} onClick={pano_visible_close}></div>
      <div className="naver_pano" id="pano" style={{ width: '100vw', height: 'calc(100vh - 22px)' }}></div>
      <div className="naver_map" ref={mapElement} style={{ width: '100vw', height: 'calc(100vh - 22px)' }}></div>
      <div className="button_wrap">
        <button className="map_button" id="cadastralBtn">지적도</button>
        <button className="map_button" id="streetLayerBtn">거리레이어</button>
        <button className="map_button" id="fullScreenBtn">전체화면</button>
      </div>
      <div className="header">
        <div className="contentWrap">
          <div className="imageBox btns"><Link to="/"><img className="logo" src={process.env.PUBLIC_URL + "images/map/image_logo.svg"}></img></Link></div>
          <div className="inputBox" onClick={() => { setInfoClick('close'); }}>
            <input id="address" className="address" type="text" placeholder="신축할 필지를 찾아보세요!" onChange={handleInputChange} onKeyDown={handleKeyDown}></input>
            <img className="search btns" src={process.env.PUBLIC_URL + "images/map/icon_search.png"} onClick={clickSearchAddress}></img>
          </div>
        </div>
        <div className="btns my_page">
          <Link to={props.userInfo === null ? '/login' : '/mypage'} state={{ returnUrl: window.location.href }}><img className="search btns" src={process.env.PUBLIC_URL + "images/map/icon_mypage.png"}></img></Link>
        </div>
        <div className="btns my_page mobile_mypage" style={{ display: 'none' }}>
          <Link to={props.userInfo === null ? '/login' : '/mypage'} state={{ returnUrl: window.location.href }}><img className="search btns" src={process.env.PUBLIC_URL + "images/map/icon_mypage_W.svg"}></img></Link>
        </div>
        <div className="btns book_mark" onClick={bookMarkInfoWindowChange}>
          <img className="search btns" src={bookMarkInfoWindow === true ? process.env.PUBLIC_URL + "images/map/icon_bookmark_allwhite.svg" : process.env.PUBLIC_URL + "images/map/icon_bookmark_white.svg"}></img>
        </div>
      </div>
      <div>
        <div className="mobile_nav">
          <div className="btns book_mark mobile_bookmark" style={{ display: 'none' }} onClick={bookMarkInfoWindowChange}>
            <img className="search btns" src={bookMarkInfoWindow === true ? process.env.PUBLIC_URL + "images/map/bookmarks_on.svg" : process.env.PUBLIC_URL + "images/map/bookmarks_off.svg"}></img>
          </div>
          <div className="mobile_menu_dot" onClick={handleMenuToggle}>
            <img className="mobile_menu" src={process.env.PUBLIC_URL + "images/map/menu_dot.svg"}></img>
          </div>
        </div>
        {isMenuOpen && (
          <div className="side_menu M_side_menu">
            <div className="custom_menu_wrap">
              <div className={`btns normal ${mapType === 'normal' ? "purple" : ""}`} onClick={() => { setMapType('normal'); window.map.setMapTypeId('normal'); window.cadastralLayer.setMap(null) }}><img className="search btns" src={mapType === 'normal' ? process.env.PUBLIC_URL + "images/map/icon_maptype_normal_purple.svg" : process.env.PUBLIC_URL + "images/map/icon_maptype_normal.svg"}></img><div>일반</div></div>
              <div className={`btns satellite ${mapType === 'satellite' ? "purple" : ""}`} onClick={() => { setMapType('satellite'); window.map.setMapTypeId('satellite'); window.cadastralLayer.setMap(null); }}><img className="search btns" src={mapType === 'satellite' ? process.env.PUBLIC_URL + "images/map/icon_satellite_purple.svg" : process.env.PUBLIC_URL + "images/map/icon_satellite.svg"}></img><div>위성</div></div>
              <div className={`btns cadastral ${mapType === 'cadastral' ? "purple" : ""}`} onClick={() => { setMapType('cadastral'); window.map.setMapTypeId('normal'); window.cadastralLayer.setMap(window.map); }}><img className="search btns" src={mapType === 'cadastral' ? process.env.PUBLIC_URL + "images/map/icon_cadastral_purple.svg" : process.env.PUBLIC_URL + "images/map/icon_cadastral.svg"}></img><div>지적도</div></div>
              <div className="row"></div>
              <div className={`btns roadview ${mapToolType === 'street' ? "purple" : ""}`} onClick={streetLayerClick}><img className="search btns" src={mapToolType === 'street' ? process.env.PUBLIC_URL + "images/map/icon_roadview_purple.svg" : process.env.PUBLIC_URL + "images/map/icon_roadview.svg"}></img><div>로드뷰</div></div>
              <div className="row"></div>
              <div className={`btns distance ${mapToolType === 'radius' ? "purple" : ""}`} onClick={() => { toolClick('radius') }}><img className="search btns" src={mapToolType === 'radius' ? process.env.PUBLIC_URL + "images/map/icon_radius_purple.svg" : process.env.PUBLIC_URL + "images/map/icon_radius.svg"}></img><div>반경</div></div>
              <div className={`btns distance ${mapToolType === 'area' ? "purple" : ""}`} onClick={() => { toolClick('area') }}><img className="search btns" src={mapToolType === 'area' ? process.env.PUBLIC_URL + "images/map/icon_area_purple.svg" : process.env.PUBLIC_URL + "images/map/icon_area.svg"}></img><div>면적</div></div>
              <div className={`btns distance ${mapToolType === 'distance' ? "purple" : ""}`} onClick={() => { toolClick('distance') }}><img className="search btns" src={mapToolType === 'distance' ? process.env.PUBLIC_URL + "images/map/icon_distance_purple.svg" : process.env.PUBLIC_URL + "images/map/icon_distance.svg"}></img><div>거리</div></div>
            </div>
            <div className="zoom_menu_wrap">
              <div className="btns plus_zoom" onClick={() => { window.map.setZoom(window.map.zoom + 1) }}></div>
              <div className="row"></div>
              <div className="btns minus_zoom" onClick={() => { window.map.setZoom(window.map.zoom - 1) }}></div>
            </div>
          </div>
        )}
      </div>
      <div className="side_menu">
        <div className="custom_menu_wrap">
          <div className={`btns normal ${mapType === 'normal' ? "purple" : ""}`} onClick={() => { setMapType('normal'); window.map.setMapTypeId('normal'); window.cadastralLayer.setMap(null) }}><img className="search btns" src={mapType === 'normal' ? process.env.PUBLIC_URL + "images/map/icon_maptype_normal_purple.svg" : process.env.PUBLIC_URL + "images/map/icon_maptype_normal.svg"}></img><div>일반</div></div>
          <div className={`btns satellite ${mapType === 'satellite' ? "purple" : ""}`} onClick={() => { setMapType('satellite'); window.map.setMapTypeId('satellite'); window.cadastralLayer.setMap(null); }}><img className="search btns" src={mapType === 'satellite' ? process.env.PUBLIC_URL + "images/map/icon_satellite_purple.svg" : process.env.PUBLIC_URL + "images/map/icon_satellite.svg"}></img><div>위성</div></div>
          <div className={`btns cadastral ${mapType === 'cadastral' ? "purple" : ""}`} onClick={() => { setMapType('cadastral'); window.map.setMapTypeId('normal'); window.cadastralLayer.setMap(window.map); }}><img className="search btns" onClick={() => { }} src={mapType === 'cadastral' ? process.env.PUBLIC_URL + "images/map/icon_cadastral_purple.svg" : process.env.PUBLIC_URL + "images/map/icon_cadastral.svg"}></img><div>지적도</div></div>
          <div className="row"></div>
          <div className={`btns roadview ${mapToolType === 'street' ? "purple" : ""}`} onClick={streetLayerClick}><img className="search btns" src={mapToolType === 'street' ? process.env.PUBLIC_URL + "images/map/icon_roadview_purple.svg" : process.env.PUBLIC_URL + "images/map/icon_roadview.svg"}></img><div>로드뷰</div></div>
          <div className="row"></div>
          <div className={`btns distance ${mapToolType === 'radius' ? "purple" : ""}`} onClick={() => { toolClick('radius') }}><img className="search btns" src={mapToolType === 'radius' ? process.env.PUBLIC_URL + "images/map/icon_radius_purple.svg" : process.env.PUBLIC_URL + "images/map/icon_radius.svg"}></img><div>반경</div></div>
          <div className={`btns distance ${mapToolType === 'area' ? "purple" : ""}`} onClick={() => { toolClick('area') }}><img className="search btns" src={mapToolType === 'area' ? process.env.PUBLIC_URL + "images/map/icon_area_purple.svg" : process.env.PUBLIC_URL + "images/map/icon_area.svg"}></img><div>면적</div></div>
          <div className={`btns distance ${mapToolType === 'distance' ? "purple" : ""}`} onClick={() => { toolClick('distance') }}><img className="search btns" src={mapToolType === 'distance' ? process.env.PUBLIC_URL + "images/map/icon_distance_purple.svg" : process.env.PUBLIC_URL + "images/map/icon_distance.svg"}></img><div>거리</div></div>
        </div>
        <div className="zoom_menu_wrap">
          <div className="btns plus_zoom" onClick={() => { window.map.setZoom(window.map.zoom + 1) }}></div>
          <div className="row"></div>
          <div className="btns minus_zoom" onClick={() => { window.map.setZoom(window.map.zoom - 1) }}></div>
        </div>
      </div>
      <Information addressInfo={addressInfo} loadingModule={loadingModule} setLoadingModule={setLoadingModule} userInfo={props.userInfo} bookMarks={props.bookMarks} setBookMarks={props.setBookMarks} bookMarkInfoWindow={bookMarkInfoWindow} setLoadingModul={setLoadingModule} infoClick={infoClick} onClick={onClick} randomPrice={randomPrice} setRandomPrice={setRandomPrice} testing={testing} getBookMarks={props.getBookMarks} />
      {props.userInfo?.name === "test" &&
        <>
          <div className="testBtnWrap">
            <div className="btns" onClick={test_01}>항목 1</div>
            <div className="btns" onClick={test_02}>항목 2</div>
            <div className="btns" onClick={test_03}>항목 3</div>
            <div className="btns" onClick={test_04}>항목 4</div>
            {/* <div className="btns" onClick={test_05}>항목 5</div> */}
            <div className="btns" onClick={makeAnswer}>정답지 만들기</div>
          </div>
        </>
      }
      <div className="footer">
        <div className="left">대표 | 고호준 || 개인정보 관리 책임자 | 이형우 || 사업자등록번호 | 469-81-03262</div>
        <div className="middle">
          <Link to={'/company'}>회사소개 | </Link>
          <Link to={'/agree'} state={{ index: 0 }}>이용약관 | </Link>
          <Link to={'/agree'} state={{ index: 1 }}>개인정보처리방침 | </Link>
          <Link to={'/agree'} state={{ index: 2 }}>위치기반 서비스 이용약관</Link>
        </div>
        <div className="right">2023ⓒ PROPMATE Inc. Corporation.All Rights Reserved. </div>
      </div>
      <Modal modalMessage={modalMessage} setLoadingModule={setLoadingModule} />
      <svg style={{ position: 'absolute', width: 0, height: 0 }}>
        <defs>
          <linearGradient id="myGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#563DF1" />
            <stop offset="50%" stopColor="#A817B5" />
            <stop offset="100%" stopColor="#6C0EE5" />
          </linearGradient>
        </defs>
      </svg>
      
    </div>
  )
}
function Modal(props) {
  const [modalState, setModalState] = useState(false);
  useEffect(() => {
    if (props.modalMessage !== '') {
      setModalState(true);
      setTimeout(function () { setModalState(false); }, 3000);
      setTimeout(function () { window.setModalMessage(''); }, 3250);
      props.setLoadingModule(false);
    }
  }, [props.modalMessage]);


  return (
    <div className={`modal ${modalState == false ? 'hide' : ''}`}>
      <div className="modalMessage">{props.modalMessage}</div>
    </div>
  )
}

export default Map;